<template>
  <confirmation-dialog ref="dialog" close-on-action>
    <template v-slot:body>
      <div class="a-container-form" v-if="bid">
        <p class="a-label a-width-100-percent">Предложение участника: №{{lot.identifier}}-{{lot.request.id}}-{{bid.num}}</p>
      </div>
      <div class="a-container-form" v-else>
        <p class="a-label a-width-100-percent">Заявка участника: №{{lot.identifier}}-{{lot.request.id}}</p>
      </div>

      <div class="a-container-form" v-if="section">
        <p class="a-label a-width-100-percent">Раздел: {{section}}</p>
      </div>

      <div class="a-container-form" >
        <textarea class="a-textarea" rows="4" v-model="adjustInfo.description"></textarea>
      </div>
      <div class="a-container-form">
        <div class="a-label a-label--auto">До: </div>
        <div class="a-flex-start a-width-100-percent">
          <div>
            <div class="a-input-group">
              <div class="a-input-group__prepend "><img src="@/assets/img/static/vector.svg" alt=""></div>
              <date-picker v-model="adjustInfo.till.date"></date-picker>
            </div>
          </div>
          <div>
            <div class="a-input-group ">
              <div class="a-input-group__prepend "><img src="@/assets/img/static/time.svg" alt=""></div>
              <cleave v-model="adjustInfo.till.time" :options="time"></cleave>
            </div>
          </div>
        </div>
      </div>
    </template>
  </confirmation-dialog>
</template>

<script>
  import ConfirmationDialog from "./ConfirmationDialog";
  import Cleave from 'vue-cleave-component'

  export default {
    props: {
      lot: {
        type: Object,
        required: true
      },
      bid: {
        type: Object
      },
      section: {
        type: String
      }
    },

    data: () => ({
      adjustInfo: {
        description: undefined,
        till: {
          date: undefined,
          time: undefined
        }
      },
      time: {
        time: true,
        timePattern: ['h', 'm'],
        delimiter: ':'
      }
    }),

    components: {
      ConfirmationDialog,
      Cleave
    },

    methods: {
      open({onConfirm}) {
        this.$refs.dialog.open({
          title: 'Резрешить редактирование',
          onConfirm: () => {
            const till =  new Date(this.adjustInfo.till.date);
            till.setHours(this.adjustInfo.till.time.slice(0, 2), this.adjustInfo.till.time.slice(2));

            onConfirm({
              description: this.adjustInfo.description,
              till
            });
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
